
import * as React from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import MuiAppBar from "@mui/material/AppBar";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import "./EventDetails.scss";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import "@aurodesignsystem/auro-input";
import "../OtsForm/AddOTSForm.scss";
import "@aurodesignsystem/auro-select";
import "@aurodesignsystem/auro-menu";
import "@aurodesignsystem/auro-combobox";
import { useHistory } from "react-router-dom";
import { OtsAircraft } from "../../Models/OtsAircraft";
import { updateOtsEvent, canReopenEvent } from "../../services/otsEventService";
import { useEffect, useState } from "react";
import * as SubActionConstant from "../../constants/SubActionConstant";
import EditModalInput from "./EditModalInput";
import EditClosedModalInput from "./EditClosedModalInput";
import { useSelector, useDispatch } from "react-redux";
import { editAircraft } from "../../store/feature/OtsAircraftSlice";
import { updateEvent, returnToService, reopenEvent } from "../../store/feature/OpenEventsListSlice";
import MessageBox from "meconversation/MessageBox";
import { useAtaCodes } from "../../providers/AtaCodeProvider";
import CloseEventModal from "../Modal/CloseEventModal";
import { useAuthentication } from "meportal/AuthenticationProvider";
import { useEventType } from "../../providers/EventTypeProvider";
import { AuthorizationAccessCheck, useAuthorization, IsAuthorized } from "meportal/AuthorizationProvider";
import {ViewManageTab, ViewMoreTab, CloseEventPermission, ViewAogPartsTab  } from "../../constants/PermissionSet";
import { useToast } from '../../providers/ToastProvider';
import MoreTabEdit from './MoreTabEdit';
import { NOTIFICATION_TYPES } from '../../components/ToastNotification/toastConstants';
import { deriveMessageTitle } from "./UpdateSubAction";
import OrderParts from "../OrderParts/OrderParts";
import { logInformation, logError } from "meportal/Logger";
import { APP_NAME_APPINSIGHTS } from "../../constants/Constants";
import { getDatetimeUtcNowString } from "../../helpers/DateTime";
import  ViewParts from "../OrderParts/ViewParts";
import Button from "../ButtonComponent/ButtonComponent";
import { postAogParts } from "../../services/otsEventService";
import { mapPartsCreateRequest } from "../OrderParts/PartsMapper";

interface TabPanelProps {
    contextPath: string;
    children?: React.ReactNode;
    index: number;
    value: number;

}
const drawerWidth = 'calc(50%)';

const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })(
    ({ theme, open }) => ({
        flexGrow: 1,
        padding: theme.spacing(3),
        transition: theme.transitions.create("margin", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        marginRight: -drawerWidth,
        ...(open && {
            transition: theme.transitions.create("margin", {
                easing: theme.transitions.easing.easeOut,
                duration: theme.transitions.duration.enteringScreen,
            }),
            marginRight: 0,
        }),
    })
);

const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
    transition: theme.transitions.create(["margin", "width"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
        width: `${drawerWidth}`,
        transition: theme.transitions.create(["margin", "width"], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
        marginRight: drawerWidth,
    }),
}));

const DrawerHeader = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: "flex-start",
}));

function CustomTabPanel(props: TabPanelProps): any {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

export default function EditModal(props: any) {
    const { contextPath } =
    props;
  const { addToast } = useToast();
  const aircraft = useSelector((state) => state.otsAircraft.otsAircraft);
  const dispatch = useDispatch();
  const history = useHistory();
  const { eventPermissions, userClaims } = useAuthorization();
  const { userData, getLatestAccessToken } = useAuthentication();
  const { eventTypes, selectedEventType, isEventTypeHttpError } = useEventType();
  const [open, setOpen] = React.useState(false);
  const [isSubmitDisabled, setIsSubmitDisabled] = React.useState(false);
  const [otsEventData, setOtsEventData] = React.useState<OtsAircraft>();
  const [postedOtsEventData, setPostedOtsEventData] = React.useState<OtsAircraft>();
  const [problemTextChanges, setProblemTextChanges] = React.useState<any>();
  const [loading, setLoader] = React.useState(true);
  const [error, setError] = React.useState(false);
  const [value, setValue] = React.useState(0);
  const [status, setStatus] = React.useState("");
  const [editedOtsEvent, setEditedOtsEvent] = React.useState<any>();
  const [editMessage, setEditMessage] = React.useState<any>();
  const [isValidComment, setIsValidComment] = React.useState(false);
  const [isValidMessageBoxComment, setIsValidMessageBoxComment] = React.useState(false);
  const [isCloseEventActive, setIsCloseEventActive] = React.useState(false);
  const [isReturnedToService, setClosedEvent] = React.useState(false);
  // controls the display of the reopen modal dialog
  const [showReopenModal, setShowReopenModal] = React.useState(false);
  const [postEventData, setPostEventData] = React.useState<SendEventData>();
  const { ataCodes } = useAtaCodes();
  const [twilioResponseStatus, setTwilioResponseStatus] = React.useState("");
  const [apiResponseStatus, setApiResponseStatus] = React.useState<{
    status: string;
    isReopen?: boolean;
  }>({ status: "" });
    const [openModal, SetOpenModal] = React.useState(false);
    const note = "note";
    const [activeHeader, setActiveHeader] = React.useState("");
    const [moreEventTitle, setMoreEventTitle] = React.useState("");
    const [isMoreTabValid, setIsMoreTabValid] = React.useState(false);
    const [moreData, setMoreData] = React.useState<any>();
    const [eventTypeIdForPermissions, setEventTypeIdForPermissions] = React.useState("");
    const [specialEventAllowed, setSpecialEventAllowed] = React.useState(false);
    const [aircraftInFlight, setAircraftInFlight] = React.useState(false);
    const [orderedParts, setOrderedParts] = React.useState<any>([]);
    const isPartsTabVisible = IsAuthorized(otsEventData?.Airline +":" + otsEventData?.EventType, ViewAogPartsTab, eventPermissions, userClaims);
    const [publicAttachmentCount, setPublicAttachmentCount] = React.useState(0);
    const moduleName = `${APP_NAME_APPINSIGHTS}-EditModal`;
    const [orderPartsResetTrigger, setOrderPartsResetTrigger] = React.useState(0);
    const [partsRefreshKey, setPartsRefreshKey] = useState(0);

    const handleActiveHeader = (header: any) => {
        setActiveHeader(header);
    }

    const handleReopenClose = () => {
        setShowReopenModal(false);
        setEditMessage("");
        setIsValidComment(false);
    };

     const [validRequest, setValidRequest] = React.useState(false);

    const handlePartsPostClick = async () => {
        if (orderedParts.length > 0) {
            setStatus("loading");
            //Temp. for twilio
            const eventdata: SendEventData = {
              IspostButtonClick: true,
              IsRemoveButtonClick: false,
              IsRestoreButtonClick: false,
              EventTitle: "Parts requested",
              UniqueConvoKey: otsEventData!.ConversationUniqueKey
            };
            try {
                const token = await getLatestAccessToken();
                const userWithToken = { ...userData, access_token: token };
                const partsCreateRequest = mapPartsCreateRequest(orderedParts, otsEventData!, userData);
                const response = await postAogParts(userWithToken, partsCreateRequest);
                if (response && response.status) {
                  setPostEventData(eventdata);  //sending twilio message
                    addToast(
                        NOTIFICATION_TYPES.SUCCESS,
                        "Parts ordered successfully."
                    );
                    setOrderedParts([]);
                    setPublicAttachmentCount(0);
                    setApiResponseStatus({ status: "success" });
                    setPartsRefreshKey((prev: number) => prev + 1);
                } else {
                    // addToast({
                    //     type: NOTIFICATION_TYPES.ERROR,
                    //     message: "Failed to order parts.",
                    // });
                    setStatus("error");
                }
            } catch (error) {
                logError(`${moduleName} - handlePartsPostClick`, error);
                addToast(
                    NOTIFICATION_TYPES.ERROR,
                    "Failed to order parts."
                );
                setStatus("error");
            }
        } else {
            // addToast({
            //     type: NOTIFICATION_TYPES.WARNING,
            //     message: "No parts to order.",
            // });
        }
    }
    
    useEffect(() => { 
      if(!aircraft.isPostClicked){
        if(history.location.pathname.includes("edit-ots")){
          handleDrawerOpen();
        }
        else {
          props.sendOpen(false);
        }
      }
    }
    , [history.location.pathname, aircraft]);
    
     useEffect(() => {
    const body = document.body;

    const updateBodyOverflow = () => {
      if (document.querySelector('.container-modal-open')) {
        body.style.overflow = 'hidden';
      } else {
        body.style.overflow = '';
      }
    };

    updateBodyOverflow();

    const observer = new MutationObserver(updateBodyOverflow);
    observer.observe(document.body, {
      attributes: true,
      childList: true,
      subtree: true,
      attributeFilter: ['class'],
    });

    window.addEventListener('resize', updateBodyOverflow);

    return () => {
      window.removeEventListener('resize', updateBodyOverflow);
      observer.disconnect();
      body.style.overflow = ''; 
    };
  }, []);

    useEffect(() => {
        if (
            apiResponseStatus.status === "success" &&
            twilioResponseStatus === "success"
        ) {
            setStatus("success");
            const eventInfo: SendEventData = {
                IspostButtonClick: false,
                IsRemoveButtonClick: false,
                IsRestoreButtonClick: false,
                EventTitle: "",
                UniqueConvoKey: "",
            };
            setPostEventData(eventInfo);
            setTimeout(() => {
                setStatus("");
                if (isCloseEventActive) {
                    window.location.href = "/";
                } else if (apiResponseStatus.isReopen) {
                    handleDrawerClose(true, postedOtsEventData?.isPostClicked);
                } else {
                    handleDrawerClose(false, postedOtsEventData?.isPostClicked);
                }
                setOpen(false);
            }, 200);
            setApiResponseStatus({ status: "" });
            setTwilioResponseStatus("");
        } else if (
            apiResponseStatus.status === "error" ||
            twilioResponseStatus === "error"
        ) {
            setStatus("error");
            const eventInfo: SendEventData = {
              IspostButtonClick: false,
              IsRemoveButtonClick: false,
              IsRestoreButtonClick: false,
              EventTitle: "",
              UniqueConvoKey: "",
          };
          setPostEventData(eventInfo);
            setTimeout(() => {
                setStatus("");
            }, 200);
            setApiResponseStatus({ status: "" });
            setTwilioResponseStatus("");
        }
    }, [apiResponseStatus, twilioResponseStatus]);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    const handleDrawerOpen = () => {
        if (aircraft.IsAirborneAtCreate && 
            aircraft.InboundFlight != null && 
            (aircraft.InboundFlight.Flight.ActualInTimeUTC== "" || 
            aircraft.InboundFlight.Flight.ActualInTimeUTC==null)
           ) {
          setAircraftInFlight(true);
          setSpecialEventAllowed(false);
        } else {
          setSpecialEventAllowed(true);
        }
        setLoader(true);
        setError(false);
        setOtsEventData(aircraft);
        setProblemTextChanges(aircraft.ProblemTextChanges);
        setClosedEvent(aircraft.ReturnToServiceTimeUTC ? true : false);
        setEventTypeIdForPermissions(aircraft.Airline+":"+aircraft.EventType);
        setLoader(false);
        setOpen(true);
        props.sendOpen(true);
        history.replace(contextPath + "/edit-ots");
    };

    const handleDrawerClose = (isReopen: boolean, isPostClicked: boolean = false) => {
        setOpen(false);
        setIsCloseEventActive(false);
        setEditMessage(""); // resets the MessageDetail component state
        setOrderPartsResetTrigger(prev => prev + 1); //reset parts component state
        //if cancel is clicked the data resets to old else updates as per user changes
        if(isPostClicked) 
        {
          dispatch(editAircraft(postedOtsEventData!));
        }
        else
        {
          dispatch(editAircraft(otsEventData!));
          setOrderedParts([]);
        }
        props.sendOpen(false);
        if (isReopen) {
            // go from the closed-events to the open-events
            history.replace("/open-events/event-details");
        } else {
            history.replace(contextPath + "/event-details");
        }
    };
    const handleClosedEventDrawerClose = () => {
      setOpen(false);
      setIsCloseEventActive(false);
      setEditMessage(""); // resets the MessageDetail component state
      if (otsEventData) {
        dispatch(editAircraft(otsEventData));
      }
      props.sendOpen(false);
      history.replace(contextPath + "/event-details");
    };
    const findClosedSubAction = (isReopen: boolean) => {
        const subActions = [];

        if (isReopen) {
            subActions.push(SubActionConstant.OTS_REOPEN);
            return subActions.join(",");
        }

        if (
            editedOtsEvent.otstime?.toISOString() !==
            (otsEventData?.OutOfServiceDateTimeUTC
                ? new Date(otsEventData?.OutOfServiceDateTimeUTC).toISOString()
                : undefined)
        ) {
            subActions.push(SubActionConstant.OTS_START_TIME);
        }
        if (
            editedOtsEvent.closedTime?.toISOString() !==
            (otsEventData?.ReturnToServiceTimeUTC
                ? new Date(otsEventData?.ReturnToServiceTimeUTC).toISOString()
                : undefined)
        ) {
            subActions.push(SubActionConstant.OTS_RETURN_TO_SERVICE_EDIT);
        }

        return subActions.join(",");
    };

    const handlePartDrawerCloseClick = () => {
      handleDrawerClose(false);
      setOrderPartsResetTrigger(prev => prev + 1);
      setOrderedParts([]);
    }

    const findSubAction = () => {
        const subActions = [];
        if (editedOtsEvent.station !== otsEventData?.Station) {
            subActions.push(SubActionConstant.STATION);
        }
        if (editedOtsEvent.location !== otsEventData?.Location) {
            subActions.push(SubActionConstant.LOCATION);
        }
        if (editedOtsEvent.ataCode !== otsEventData?.ATACode?.toString()) {
            subActions.push(SubActionConstant.ATA);
        }
        if (
            editedOtsEvent.advtime?.toISOString() !==
            (otsEventData?.AdviseTimeUTC
                ? new Date(otsEventData?.AdviseTimeUTC).toISOString()
                : undefined)
        ) {
            subActions.push(SubActionConstant.ADV);
        }
        if (
            editedOtsEvent.etrtime?.toISOString() !==
            (otsEventData?.EstimatedReturnToServiceTimeUTC
                ? new Date(otsEventData?.EstimatedReturnToServiceTimeUTC).toISOString()
                : undefined)
        ) {
            subActions.push(SubActionConstant.ETR);
        }
        if (
            editedOtsEvent.otstime?.toISOString() !==
            (otsEventData?.OutOfServiceDateTimeUTC
                ? new Date(otsEventData?.OutOfServiceDateTimeUTC).toISOString()
                : undefined)
        ) {
            subActions.push(SubActionConstant.OTS_START_TIME);
        }
        if (editedOtsEvent.problemText !== otsEventData?.ProblemText) {
            subActions.push(SubActionConstant.PROBLEM_TEXT);
        }
        return subActions.join(",");
    };

    const formatTime = (time: string) => {
        if (time === undefined) return null;
        let rightFormat = new Date(time);
        return rightFormat.toISOString();
    };

    const getTime = (originalTime: any, updatedTime: any) => {
        if (isCloseEventActive) {
            let dateTime =
                originalTime !== null ? new Date(originalTime).toISOString() : null;
            return dateTime;
        } else {
            let dateTime =
                updatedTime !== undefined &&
                    updatedTime !== null &&
                    !isNaN(updatedTime.getTime())
                    ? updatedTime?.toISOString()
                    : null;
            return dateTime;
        }
    };

    const getOtsTime = (
        originalTime: any,
        updatedTime: any,
        isReopen: boolean
    ) => {
        if (isCloseEventActive || isReopen) {
            let dateTime =
                originalTime !== null ? new Date(originalTime).toISOString() : null;
            return dateTime;
        } else {
            let dateTime =
                updatedTime !== undefined &&
                    updatedTime !== null &&
                    !isNaN(updatedTime.getTime())
                    ? updatedTime?.toISOString()
                    : null;
            return dateTime;
        }
    };

  const dataSubmission = () => {
    if (otsEventData){
      let updatedOtsEventData: UpdatedOtsEvent = {
        id: otsEventData.id,
        action: "UPDATE",
        subAction: isCloseEventActive
          ? SubActionConstant.OTS_RETURN_TO_SERVICE
          : findSubAction(),
        airline: otsEventData!.Airline,
        aircraftRegistration: "N" + otsEventData!.AircraftRegistration,
        eventType: otsEventData.EventType,
        eventTypeCategory: otsEventData!.EventTypeCategory,
        eventTypeTo: otsEventData.EventTypeTo || "",
        eventTypeCategoryTo: otsEventData.EventTypeCategoryTo || "",
        station: isCloseEventActive
          ? otsEventData.Station
          : editedOtsEvent.station,
        location: isCloseEventActive
          ? otsEventData.Location
          : editedOtsEvent.location,
        problemText: isCloseEventActive
          ? otsEventData.ProblemText
          : editedOtsEvent.problemText,
        // problemTextChanges: otsEventData?.ProblemTextChanges ?? [],
        outOfServiceDateTimeUTC: getTime(
          otsEventData.OutOfServiceDateTimeUTC,
          editedOtsEvent.otstime
        ),
        adviseTimeUTC: getTime(
          otsEventData.AdviseTimeUTC,
          editedOtsEvent.advtime
        ),
        estimatedReturnToServiceTimeUTC: getTime(
          otsEventData.EstimatedReturnToServiceTimeUTC,
          editedOtsEvent.etrtime
        ),
        returnToServiceTimeUTC: isCloseEventActive
          ? new Date().toISOString()
          : null,
        ATACode: isCloseEventActive
          ? otsEventData.ATACode
          : editedOtsEvent.ataCode,
        ataCodeDescription: isCloseEventActive
          ? otsEventData.AtaCodeDescription
          : editedOtsEvent.ataCodeDescription,
        isEtopsCapable: otsEventData.IsEtopsCapable,
        conversationUniqueKey: otsEventData.ConversationUniqueKey,
        hasPublicAttachment: attachmenthandler(),
        lastUpdatedBy: userData?.profile?.name,
      };
      return updatedOtsEventData;
    };
  };

  const attachmenthandler=()=>{
      let res= false;
      if(otsEventData.HasPublicAttachment){
          res=true;
      }
      else{
          if(editMessage?.comment){
              res=false;
          }
          else{
              return publicAttachmentCount > 0;
          }
      }

      return res;
  }

    const editClosedDataSubmission = (isReopen: boolean) => {
    if (otsEventData){ 
      let updatedOtsEventData: UpdatedOtsEvent = {
      id: otsEventData!.id,
      action: "UPDATE",
      subAction: findClosedSubAction(isReopen),
      airline: otsEventData.Airline,
      aircraftRegistration: "N" + otsEventData!.AircraftRegistration,
      eventType: otsEventData.EventType,
      eventTypeCategory: otsEventData!.EventTypeCategory,
      eventTypeTo: otsEventData.EventTypeTo || "",
      eventTypeCategoryTo: otsEventData.EventTypeCategoryTo || "",
      station: otsEventData.Station,
      location: otsEventData.Location,
      problemText: otsEventData.ProblemText,
      //problemTextChanges: otsEventData.ProblemTextChanges,
      outOfServiceDateTimeUTC: getOtsTime(
        otsEventData.OutOfServiceDateTimeUTC,
        editedOtsEvent.otstime,
        isReopen
      ),
      // outOfServiceDateTimeChanges:
      //   otsEventData.OutOfServiceDateTimeChanges,
      adviseTimeUTC: otsEventData.AdviseTimeUTC
        ? formatTime(otsEventData.AdviseTimeUTC)
        : null,
      // adviseTimeChanges: otsEventData.AdviseTimeChanges,
      estimatedReturnToServiceTimeUTC: otsEventData.EstimatedReturnToServiceTimeUTC
        ? formatTime(otsEventData.EstimatedReturnToServiceTimeUTC)
        : null,
      //estimatedReturnToServiceTimeChanges: otsEventData.EstimatedReturnToServiceTimeChanges,
      returnToServiceTimeUTC: isReopen
        ? null
        : getTime(
          otsEventData!.ReturnToServiceTimeUTC,
          editedOtsEvent.closedTime
        ),
      // returnToServiceTimeChanges: otsEventData.ReturnToServiceTimeChanges,
      ATACode: otsEventData.ATACode,
      ataCodeDescription: otsEventData.AtaCodeDescription,
      isEtopsCapable: otsEventData.IsEtopsCapable,
      // createdBy: otsEventData.CreatedBy,
      conversationUniqueKey: otsEventData.ConversationUniqueKey,
      // createdDateTimeUTC: otsEventData.CreatedDateTimeUTC,
      hasPublicAttachment:attachmenthandler(),
      lastUpdatedBy: userData?.profile?.name,
      };
      return updatedOtsEventData;
    }
  };
  function otsStartTimeNeedsToChange(otsEventData: OtsAircraft) {
    // if (otsEventData.OutOfServiceDateTimeUTC && 
    //     otsEventData.InboundFlight && 
    //     otsEventData.InboundFlight.Flight.ActualInTimeUTC) {
    //    return true;
    // }
    return false;
  }

  const moreTabDataSubmission = () => {
    // if the event type is changeing from airborne to a non-airborne event type, 
    // the out of service time must change to current time.  This is true only for the first time the event type is changed 
    let otsStartTime = otsEventData!.OutOfServiceDateTimeUTC;
    console.log("evnet type category for submission",moreData?.eventTypeCategory);
    if (otsEventData!.IsAirborneAtCreate && moreData?.eventTypeCategory != "NotApplicable") {
      if (otsStartTimeNeedsToChange(otsEventData!)) {
        const currentDate = new Date();
        otsStartTime = currentDate.toISOString();
      }
    }
    
    let updatedOtsEventData: UpdatedOtsEvent = {
      id: otsEventData!.id,
      action: "UPDATE",
      subAction: moreData?.subAction,
      airline: otsEventData!.Airline,
      aircraftRegistration: "N" + otsEventData!.AircraftRegistration,
      eventType: moreData?.eventType ?? otsEventData!.EventType,
      eventTypeCategory: moreData?.eventTypeCategory ?? otsEventData!.EventTypeCategory,
      eventTypeTo: moreData?.eventTypeTo ?? otsEventData!.EventTypeTo ?? "",
      eventTypeCategoryTo: moreData?.eventTypeCategoryTo ?? otsEventData!.EventTypeCategoryTo ?? "",
      station: otsEventData!.Station,
      location: otsEventData!.Location,
      problemText: otsEventData!.ProblemText,
      outOfServiceDateTimeUTC: otsStartTime,
      adviseTimeUTC: otsEventData!.AdviseTimeUTC? formatTime(otsEventData!.AdviseTimeUTC): null,
      estimatedReturnToServiceTimeUTC: otsEventData!.EstimatedReturnToServiceTimeUTC? formatTime(otsEventData!.EstimatedReturnToServiceTimeUTC): null, 
      returnToServiceTimeUTC: otsEventData!.ReturnToServiceTimeUTC? formatTime(otsEventData!.ReturnToServiceTimeUTC): null,
      ATACode: otsEventData!.ATACode,
      ataCodeDescription: otsEventData!.AtaCodeDescription,
      isEtopsCapable: otsEventData!.IsEtopsCapable,
      conversationUniqueKey: otsEventData!.ConversationUniqueKey,
      specialEvent: setSpecialEvent(),
      hasPublicAttachment: attachmenthandler(),
      lastUpdatedBy: userData?.profile?.name,
    };
    return updatedOtsEventData;
  };

  const setSpecialEvent = (): SpecialEvent | null => {
    if (moreData && moreData.specialEventCategory) { 
      return {
        SpecialEventType: moreData.specialEventCategory,
        SpecialEventStationFrom: moreData.fromLocation,
        SpecialEventStationTo: moreData.toLocation
      };
    };
    return null;
  }

  const handleClosebox = () => {
    SetOpenModal(false);
    setEditMessage("");
    setIsValidComment(false);
    setIsCloseEventActive(false);
  }

  const handlePostClick = () => {
    setStatus("loading");
    let updatedOtsEvent: UpdatedOtsEvent | undefined;
    if (isReturnedToService) {
      updatedOtsEvent = editClosedDataSubmission(false);
    } else {
      updatedOtsEvent = dataSubmission();
    }
    if (!updatedOtsEvent) {
      return;
    }
    console.log(" checking value Updated ots event", updatedOtsEvent);
    let title = deriveMessageTitle(updatedOtsEvent.subAction, updatedOtsEvent, otsEventData!);
    const eventdata: SendEventData = {
      IspostButtonClick: true,
      IsRemoveButtonClick: false,
      IsRestoreButtonClick: false,
      EventTitle: activeHeader?.includes(note) && updatedOtsEvent.subAction != SubActionConstant.OTS_RETURN_TO_SERVICE ? "" : title,
      UniqueConvoKey: updatedOtsEvent.conversationUniqueKey,
      PublicMsg: editMessage?.comment
    };
    SetOpenModal(false);
    
    //if adding notes not making the API call
    if(activeHeader?.includes(note) && updatedOtsEvent.subAction != SubActionConstant.OTS_RETURN_TO_SERVICE){
      setPostEventData(eventdata);  //sending twilio message
      logInformation(
        `${getDatetimeUtcNowString("YYYY-MM-DD HH:mm:ss")}Z => Sending message add (note) to conversation UI. ${JSON.stringify(eventdata)} User: ${userData?.profile?.email}`,
        moduleName,
        "handlePostClick"
      );
      setApiResponseStatus({ status: "success" });
    }
    else{
      const currentUTCTime = new Date().toISOString();
      getLatestAccessToken().then((token: any) => {
        userData.access_token = token;
        updateOtsEvent(userData, updatedOtsEvent)
          .then(({statusCode, responseData}) => {
            if (statusCode === 200) {
              setPostEventData(eventdata); //sending twilio message
              logInformation(
                `${getDatetimeUtcNowString("YYYY-MM-DD HH:mm:ss")}Z => Success API response and sending message add (non note) to conversation UI. ${JSON.stringify(eventdata)} User: ${userData?.profile?.email}`,
                moduleName,
                "handlePostClick"
              );
              //Update the redux state with the updated event data for single aircraft
              if(otsEventData)
                {
                  let postedEventData = { ...otsEventData };
                  MappingNewValuesToOTSAircraftEntity(postedEventData,updatedOtsEvent,currentUTCTime);
                  setPostedOtsEventData(postedEventData);
                }
                
              setApiResponseStatus({ status: "success" });
              // update the event data in the dashboard store to reflect the changes
              // if it is a return to service, remove it from the dashboard 
             handleSuccessAction(updatedOtsEvent);
            }  else if (statusCode === 400) {
              setApiResponseStatus({ status: "error" });
              history.push(contextPath + "/event-details");
              handleClosedEventDrawerClose();
              if (Array.isArray(responseData) && responseData.length > 0) {
                responseData.forEach((message, index) => {
                  if (typeof message === 'string') {
                    addToast(
                      NOTIFICATION_TYPES.WARNING,
                      'Unable to close event.',
                      message,
                      false,
                      true
                    );
                  }
              });
              } 
            } else {
              setApiResponseStatus({ status: "error" });
              history.push(contextPath + "/event-details");
              handleClosedEventDrawerClose(); 
              addToast(NOTIFICATION_TYPES.WARNING, 'Unable to close event.', `${responseData}`, false, true);
            }
          })
          .catch((error) => {
            setApiResponseStatus({ status: "error" });
            history.push(contextPath + "/event-details");
            handleClosedEventDrawerClose();
            addToast(NOTIFICATION_TYPES.INFO,  'Unable to close event.', `${(error)}`, false, true);
        });
      });
    }
  };

  const handleSuccessAction=(updatedOtsEvent:any)=>{
       if(updatedOtsEvent.subAction == SubActionConstant.OTS_RETURN_TO_SERVICE) {
                dispatch(returnToService(updatedOtsEvent.id))
              } else {
                dispatch(updateEvent(updatedOtsEvent));
              }
  }
  const handleMoreTabPostClick = () => {
    setStatus("loading");
    const eventdata: SendEventData = {
      IspostButtonClick: true,
      IsRemoveButtonClick: false,
      IsRestoreButtonClick: false,
      EventTitle: moreEventTitle,
      UniqueConvoKey: otsEventData!.ConversationUniqueKey,
      SpecialEventCategory: moreData?.specialEventCategory
    };
      SetOpenModal(false);
      //call API to update the data
      let updatedOtsEvent = moreTabDataSubmission();
      console.log("Posting more data submission - ots start time reset with airborne to u/s", updatedOtsEvent);
      const currentUTCTime = new Date().toISOString();
      getLatestAccessToken().then((token) => {
        userData.access_token = token;
        updateOtsEvent(userData, updatedOtsEvent)
        .then(({statusCode, responseData}) => {
          if (statusCode === 200) {
            setPostEventData(eventdata); //sending twilio message
            logInformation(
              `${getDatetimeUtcNowString("YYYY-MM-DD HH:mm:ss")}Z => Success API response and sending message add to conversation UI. ${JSON.stringify(eventdata)} User: ${userData?.profile?.email}`,
              moduleName,
              "handleMoreTabPostClick"
            );
            //Update the redux state with the updated event data for single aircraft
            if(otsEventData)
              {
      let postedEventData = { ...otsEventData };
      MappingNewValuesToOTSAircraftEntity(postedEventData,updatedOtsEvent,currentUTCTime);
                setPostedOtsEventData(postedEventData);

    }
            dispatch(updateEvent(updatedOtsEvent));
            setApiResponseStatus({ status: "success" });
          } else {
            setApiResponseStatus({ status: "error" });
          }
        })
        .catch(() => {
          setApiResponseStatus({ status: "error" });
        });
      });
  };
  // function callback handler sent to the EditClosedModalInput component to control
  // when the reopen modal dialog is shown
  const handleReopenClick = () => {
    // validate the event can be reopened
    // validate the event type is active 
    let activeEvent = eventTypes.filter((eventType) => eventType.Name === otsEventData?.EventType && eventType.IsActive);
    if (activeEvent.length === 0) {
      //setStatus("error");
      setShowReopenModal(false);
      addToast(NOTIFICATION_TYPES.WARNING, 'Event type ' + otsEventData?.EventType +  ' is inactive.  Cannot reopen event.', '');
      
    } else {
      getLatestAccessToken().then((token) => {  
        userData.access_token = token;
        canReopenEvent(userData, otsEventData!).then(
          (data) => {
            if (data.IsAlreadyOpen || data.IsAirborne) {
              setShowReopenModal(false);
              if (data.IsAlreadyOpen) {
                addToast(NOTIFICATION_TYPES.WARNING, 'Event is already open.', '');
              } else {
                addToast(NOTIFICATION_TYPES.WARNING, 'Event is airborne. Cannot reopen.', '');
              }
              
            } else {
              setShowReopenModal(true);
            }
          },
          (error) => {
            setShowReopenModal(false);
            addToast(NOTIFICATION_TYPES.WARNING, 'Failed to reopen the event', '');
           
          }
        );
      });
    }
  };
  // function callback handler sent to the EditClosedModalInput component to control actions
  // when the user clicks the "Reopen" button
  const handleReopenConfirmed = () => {
    setStatus("loading");
    let updatedOtsEvent = editClosedDataSubmission(true);
    if (!updatedOtsEvent) {
      return; 
    }
    let title = deriveMessageTitle(updatedOtsEvent.subAction,updatedOtsEvent,otsEventData!);
    const eventdata: SendEventData = {
      IspostButtonClick: true,
      IsRemoveButtonClick: false,
      IsRestoreButtonClick: false,
      EventTitle: title,
      UniqueConvoKey: updatedOtsEvent.conversationUniqueKey,
      PublicMsg: editMessage?.comment
    };
    setShowReopenModal(false);
    // save the data
    const currentUTCTime = new Date().toISOString();
    getLatestAccessToken().then((token) => {
      userData.access_token = token;
      updateOtsEvent(userData, updatedOtsEvent)
        .then(({statusCode, responseData}) => {
          if (statusCode === 200) {
            setPostEventData(eventdata); //sending twilio message
            logInformation(
              `${getDatetimeUtcNowString("YYYY-MM-DD HH:mm:ss")}Z => Success API response and sending message add to conversation UI. ${JSON.stringify(eventdata)} User: ${userData?.profile?.email}`,
              moduleName,
              "handleReopenConfirmed"
            );
            //Update the redux state with the updated event data for single aircraft
            if(otsEventData)
              {
                let postedEventData = { ...otsEventData };
                MappingNewValuesToOTSAircraftEntity(postedEventData,updatedOtsEvent,currentUTCTime);
                setPostedOtsEventData(postedEventData);
              }
            dispatch(reopenEvent(updatedOtsEvent));
            setApiResponseStatus({ status: "success", isReopen: true });
          } else {
            setApiResponseStatus({ status: "error" });
            console.log("Failure ReopenOTSEvent", error);
          }
        })
        .catch(() => {
          setApiResponseStatus({ status: "error" });
          console.log("Failed Error ReopenOTSEvent");
        });
    });
  };

    const handleEditDataChange = (editedOtsEvent: any) => {
        setEditedOtsEvent(editedOtsEvent);
        setIsSubmitDisabled(editedOtsEvent.isSubmitDisabled);
    };

    const handleEditClosedDataChange = (editedOtsEvent: any) => {
        setEditedOtsEvent(editedOtsEvent);
        setIsSubmitDisabled(editedOtsEvent.isSubmitDisabled);
    };

    const checkCloseButtonEnable=()=>{
       return canCloseEvent() ? "" : "disabled";
    }
    const checkIsActiveEvent=()=>{
         return isCloseEventActive ? "Event closed successfully!" : "Event updated successfully!";
    }
    const handleMessageDataChange = (messageData: any) => {
        setEditMessage(messageData);
        setIsValidComment(messageData.isValidComment);
    };
    const handleMessageBoxValidComment = (data: any) => {
        setIsValidMessageBoxComment(data.isValidComment);
    };

    const onCloseEventClicked = () => {
        SetOpenModal(true);
        setIsCloseEventActive(true);
        setIsSubmitDisabled(false);
    };

    const handleTwilioMessageSent = (twilioResponse: any) => {
        if (twilioResponse){
          setTwilioResponseStatus("success");
          logInformation(
            `${getDatetimeUtcNowString("YYYY-MM-DD HH:mm:ss")}Z => Success response from conversation add message. ${otsEventData?.ConversationUniqueKey} ${JSON.stringify(twilioResponse)} User: ${userData?.profile?.email}`,
            moduleName,
            "handleTwilioMessageSent"
          );
        } 
        else {
          setTwilioResponseStatus("error");
          logError(
            `${getDatetimeUtcNowString("YYYY-MM-DD HH:mm:ss")}Z => Conversation message addition failed. Conversation key: ${otsEventData?.ConversationUniqueKey} User: ${userData?.profile?.email}`,
            moduleName,
            "handleTwilioMessageSent"
          );
        }
    };

    const handleMoreTabData = (moreTabData: any) => {
        setMoreEventTitle(moreTabData.moreEventTitle);
        setIsMoreTabValid(moreTabData.moreTabValid);
        setMoreData(moreTabData);
    }
    function setConversationTitles() { 
      if (isReturnedToService){
        return { hideBoth: false, hideNote: true }; 
      } 
      return { hideBoth: false, hideNote: false }; 
    }

    const checkCloseEventActive=()=>{
        return isCloseEventActive ? "only-comment" : "";
    }
    const handleClassFromActiveHeader=()=>{
       return activeHeader?.includes(note) ? "only-note" : "";
    }
    const handlePublicAttachmentCount = (count: number) => {
      setPublicAttachmentCount(count);
  }
  const canCloseEvent = () => {
    return IsAuthorized(otsEventData?.Airline +":" + otsEventData?.EventType, CloseEventPermission, eventPermissions, userClaims);
  }
  
  return (
    <div>
      <Box sx={{ display: "flex" }}>
        <CssBaseline />
        <Main open={open}>
          <DrawerHeader />
        </Main>
        <Drawer
          id="edit-modal-drawer"
          sx={{
            width: drawerWidth,
            flexShrink: 0,
            "& .MuiDrawer-paper": {
              width: drawerWidth,
            },
          }}
          variant="persistent"
          anchor="right"
          open={open}
        >
          <DrawerHeader>
            <Tabs 
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
            >
               <Tab
               value={0}
                className="tab-label"
                label={isCloseEventActive ? "Close event" : "Manage event"}
                icon={ <svg
                  className="tool-kit"
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M5.57112 15.3124L8.23174 12.6518L7.34799 11.7681L4.68737 14.4287L4.19174 13.9331C4.07454 13.8159 3.91559 13.7501 3.74987 13.7501C3.58414 13.7501 3.4252 13.8159 3.30799 13.9331L0.807992 16.4331C0.690822 16.5503 0.625 16.7092 0.625 16.8749C0.625 17.0407 0.690822 17.1996 0.807992 17.3168L2.68299 19.1918C2.8002 19.309 2.95914 19.3748 3.12487 19.3748C3.29059 19.3748 3.44954 19.309 3.56674 19.1918L6.06674 16.6918C6.18391 16.5746 6.24973 16.4157 6.24973 16.2499C6.24973 16.0842 6.18391 15.9253 6.06674 15.8081L5.57112 15.3124ZM3.12487 17.8662L2.13362 16.8749L3.74987 15.2587L4.74112 16.2499L3.12487 17.8662Z"
                    fill="var(--rain-blue-dark, #0074CB)"
                  />
                  <path
                    d="M14.9999 18.7498C14.0057 18.7486 13.0526 18.3531 12.3496 17.6501C11.6465 16.9471 11.2511 15.994 11.2499 14.9998C11.2502 14.673 11.2944 14.3478 11.3812 14.0329L5.96743 8.61851C5.65225 8.70533 5.32685 8.74948 4.99993 8.74976C4.38895 8.7522 3.78669 8.60472 3.24597 8.32024C2.70526 8.03576 2.24258 7.62298 1.89852 7.11808C1.55445 6.61318 1.3395 6.03158 1.27252 5.42428C1.20553 4.81697 1.28855 4.20251 1.5143 3.63476L1.86305 2.74663L3.93305 4.81663C4.052 4.93022 4.21015 4.9936 4.37462 4.9936C4.53909 4.9936 4.69723 4.93022 4.81618 4.81663C4.87427 4.75864 4.92036 4.68976 4.9518 4.61394C4.98324 4.53812 4.99943 4.45684 4.99943 4.37476C4.99943 4.29268 4.98324 4.2114 4.9518 4.13558C4.92036 4.05975 4.87427 3.99088 4.81618 3.93288L2.7468 1.86163L3.63618 1.51351C4.20392 1.28816 4.81826 1.20547 5.42538 1.27268C6.0325 1.3399 6.61388 1.55496 7.11858 1.89904C7.62328 2.24311 8.03591 2.7057 8.32032 3.24628C8.60473 3.78686 8.75224 4.38893 8.74993 4.99976C8.74965 5.32647 8.7055 5.65167 8.61868 5.96663L14.0331 11.381C14.348 11.2943 14.6732 11.2502 14.9999 11.2498C15.6109 11.2473 16.2132 11.3948 16.7539 11.6793C17.2946 11.9638 17.7573 12.3765 18.1013 12.8814C18.4454 13.3863 18.6604 13.9679 18.7273 14.5752C18.7943 15.1825 18.7113 15.797 18.4856 16.3648L18.1374 17.2529L16.0668 15.1829C15.9479 15.0693 15.7897 15.0059 15.6252 15.0059C15.4608 15.0059 15.3026 15.0693 15.1837 15.1829C15.1255 15.2408 15.0794 15.3097 15.0479 15.3855C15.0164 15.4613 15.0002 15.5425 15.0001 15.6246C15.0001 15.7067 15.0162 15.788 15.0476 15.8638C15.079 15.9397 15.125 16.0086 15.1831 16.0666L17.2537 18.1373L16.3649 18.486C15.9305 18.6588 15.4674 18.7483 14.9999 18.7498ZM6.28868 7.17226L12.8268 13.7104L12.6774 14.0916C12.531 14.4576 12.4738 14.8531 12.5105 15.2455C12.5472 15.6379 12.6767 16.016 12.8883 16.3484C13.0999 16.6809 13.3876 16.9583 13.7276 17.1576C14.0676 17.3569 14.4502 17.4725 14.8437 17.4948L14.2993 16.951C14.1252 16.7769 13.987 16.5702 13.8928 16.3427C13.7985 16.1152 13.75 15.8713 13.75 15.6251C13.75 15.3788 13.7985 15.135 13.8928 14.9075C13.987 14.68 14.1252 14.4732 14.2993 14.2991C14.6565 13.9581 15.1314 13.7678 15.6252 13.7678C16.1191 13.7678 16.594 13.9581 16.9512 14.2991L17.4949 14.8435C17.4726 14.45 17.3569 14.0674 17.1575 13.7275C16.9581 13.3875 16.6807 13.0998 16.3482 12.8881C16.0157 12.6765 15.6376 12.547 15.2451 12.5104C14.8527 12.4737 14.4571 12.5309 14.0912 12.6773L13.7106 12.8266L7.17305 6.28913L7.32305 5.90788C7.46945 5.54191 7.52666 5.14635 7.48996 4.75389C7.45326 4.36143 7.3237 3.98334 7.112 3.65085C6.90029 3.31836 6.61251 3.04101 6.27243 2.84173C5.93234 2.64245 5.54972 2.52694 5.15618 2.50476L5.69993 3.04851C5.87407 3.22262 6.01221 3.42934 6.10646 3.65684C6.20071 3.88435 6.24922 4.12819 6.24922 4.37445C6.24922 4.6207 6.20071 4.86455 6.10646 5.09205C6.01221 5.31956 5.87407 5.52627 5.69993 5.70038C5.34274 6.04145 4.86786 6.23176 4.37399 6.23176C3.88012 6.23176 3.40524 6.04145 3.04805 5.70038L2.5043 5.15601C2.52658 5.5495 2.64215 5.93205 2.84148 6.27205C3.0408 6.61205 3.31816 6.89975 3.65063 7.11139C3.98311 7.32303 4.36117 7.45253 4.75358 7.48919C5.14599 7.52586 5.5415 7.46864 5.90743 7.32226L6.28868 7.17226Z"
                    fill="var(--rain-blue-dark, #0074CB)"
                  />
                  <path
                    d="M18.2019 1.78137C17.8447 1.44031 17.3698 1.25 16.8759 1.25C16.3821 1.25 15.9072 1.44031 15.55 1.78137L10.875 6.45637L11.7587 7.34012L16.4338 2.66512C16.5528 2.55149 16.7111 2.4881 16.8756 2.4881C17.0402 2.4881 17.1984 2.55149 17.3175 2.66512C17.4344 2.78249 17.5 2.94137 17.5 3.107C17.5 3.27262 17.4344 3.4315 17.3175 3.54887L12.6425 8.22387L13.5263 9.10825L18.2013 4.43325C18.5525 4.08136 18.7498 3.60449 18.7498 3.10731C18.7498 2.61012 18.5531 2.13325 18.2019 1.78137Z"
                    fill="var(--rain-blue-dark, #0074CB)"
                  />
                </svg>} 
                iconPosition="end"
                {...a11yProps(0)}
                disabled ={IsAuthorized(otsEventData?.Airline +":" + otsEventData?.EventType, ViewManageTab, eventPermissions, userClaims) ? false : true}
              />
              {isPartsTabVisible && !isReturnedToService &&
               <Tab
               value={1}
                className="tab-label"
                icon={<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M3.63314 6.88943C4.56614 6.16443 5.34014 6.66443 6.37314 7.86043C6.48914 7.99543 6.64514 7.83743 6.73414 7.76043C6.82314 7.68343 8.18514 6.45543 8.25214 6.39943C8.31814 6.34043 8.39814 6.23043 8.29314 6.10743C8.04018 5.79461 7.79247 5.47756 7.55014 5.15643C5.74214 2.79143 12.4961 1.18743 11.4591 1.16243C10.9311 1.14843 8.81314 1.12343 8.49614 1.15843C7.21314 1.29343 5.60214 2.49243 4.79114 3.05143C3.73014 3.77743 3.33414 4.20343 3.26914 4.26243C2.96914 4.52443 3.22114 5.12943 2.67714 5.60643C2.10214 6.10943 1.74314 5.72843 1.41014 6.02043C1.24514 6.16643 0.78314 6.51243 0.65114 6.62743C0.51814 6.74443 0.49414 6.94143 0.63014 7.09843C0.63014 7.09843 1.89414 8.49443 2.00014 8.61843C2.10514 8.74043 2.39114 8.84643 2.56714 8.68943C2.74414 8.53343 3.19914 8.13643 3.27514 8.06643C3.35314 8.00043 3.22514 7.20543 3.63314 6.88943ZM9.34114 7.40643C9.22114 7.26743 9.07214 7.26343 8.94414 7.37743L7.51014 8.62943C7.455 8.6798 7.42142 8.7495 7.41639 8.82401C7.41136 8.89853 7.43527 8.97211 7.48314 9.02943L15.7771 18.4684C15.9711 18.6914 16.3071 18.7144 16.5281 18.5214L17.4981 17.7084C17.6049 17.6144 17.6703 17.4821 17.68 17.3401C17.6897 17.1982 17.6431 17.0582 17.5501 16.9504L9.34114 7.40643ZM20.4001 3.38943C20.3261 2.89543 20.0701 2.99843 19.9371 3.20743C19.8041 3.41843 19.2161 4.30943 18.9741 4.71343C18.7341 5.11343 18.1421 5.90443 17.0401 5.12343C15.8921 4.31243 16.2911 3.74643 16.4911 3.36543C16.6921 2.98243 17.3091 1.90843 17.3981 1.77543C17.4871 1.64043 17.3831 1.24843 17.0271 1.41243C16.6701 1.57643 14.5041 2.43743 14.2041 3.67243C13.8971 4.92843 14.4611 6.05143 13.3541 7.16643L12.0111 8.56643L13.3601 10.1324L15.0141 8.56243C15.4081 8.16643 16.2501 7.78143 17.0121 7.95543C18.6451 8.32443 19.5361 7.71143 20.0731 6.69743C20.5551 5.79143 20.4751 3.88343 20.4001 3.38943ZM3.23714 17.0524C3.13759 17.1535 3.08179 17.2896 3.08179 17.4314C3.08179 17.5733 3.13759 17.7094 3.23714 17.8104L4.18814 18.7404C4.39614 18.9494 4.72614 18.8614 4.93414 18.6524L9.84114 13.8284L8.33814 12.1144L3.23714 17.0524Z" fill="#054687"/>
                </svg>}
                iconPosition="end"
                label="Parts" {...a11yProps(1)}   
                >
                </Tab>}
             
             {!isReturnedToService && ( 
              
             <Tab
             value={2}
                className="tab-label"
                icon={<svg className="tool-kit" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path fillRule="evenodd" clipRule="evenodd" d="M10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0ZM10 1.5C5.30558 1.5 1.5 5.30558 1.5 10C1.5 14.6944 5.30558 18.5 10 18.5C14.6944 18.5 18.5 14.6944 18.5 10C18.5 5.30558 14.6944 1.5 10 1.5ZM7 10C7 10.8284 6.32843 11.5 5.5 11.5C4.67157 11.5 4 10.8284 4 10C4 9.17157 4.67157 8.5 5.5 8.5C6.32843 8.5 7 9.17157 7 10ZM15.75 10C15.75 10.8284 15.0784 11.5 14.25 11.5C13.4216 11.5 12.75 10.8284 12.75 10C12.75 9.17157 13.4216 8.5 14.25 8.5C15.0784 8.5 15.75 9.17157 15.75 10ZM10 11.5C10.8284 11.5 11.5 10.8284 11.5 10C11.5 9.17157 10.8284 8.5 10 8.5C9.17157 8.5 8.5 9.17157 8.5 10C8.5 10.8284 9.17157 11.5 10 11.5Z" fill="var(--rain-blue-dark, #0074CB)" />
              </svg>}
                label="More" {...a11yProps(2)}
                iconPosition="end" 
                disabled={IsAuthorized(otsEventData?.Airline + ":" + otsEventData?.EventType, ViewMoreTab, eventPermissions, userClaims) ? false : true}
                />  
               )}
            </Tabs>
          </DrawerHeader>
          <Divider />

          <CustomTabPanel value={value} index={0}>
            {loading ? (
              <div>Loading...</div>
            ) : error ? (
              <div>No valid details for aircraft found.</div>
            ) : (
              <span className={checkCloseEventActive()}>
                {otsEventData && !isReturnedToService ? (
                  <div className={handleClassFromActiveHeader()}>
                    
                    <EditModalInput
                      onEditOts={otsEventData}
                      ataCodeList={ataCodes}
                      onEditDataChange={handleEditDataChange}
                      reset={open}
                      aircraftInFlight={aircraftInFlight}
                      airline={userData?.profile?.company}
                    ></EditModalInput>
                  </div>
                  ) : ( otsEventData &&
                        isReturnedToService && (
                            <div className={handleClassFromActiveHeader()}>
                              <EditClosedModalInput
                                onEditOts={otsEventData}
                                onEditDataChange={handleEditClosedDataChange}
                                showReopenModal={showReopenModal}
                                isValidComment={isValidComment}
                                handleModalClose={handleReopenClose}
                                handleModalConfirm={handleReopenConfirmed}
                                handleMessage={handleMessageDataChange}
                                reset={open}
                              ></EditClosedModalInput></div>
                        )
                      )
                }

                <footer className="modal-more-footer">
                  <MessageBox className="edit-comment-box"
                              onMessageDataChange={handleMessageBoxValidComment}
                              eventData={postEventData}
                              resetBox={open}
                              activeBoxHeader={handleActiveHeader}
                              onTwilioMessageSent={handleTwilioMessageSent}
                              hiddenHeader={ setConversationTitles()}
                              eventTypeId={eventTypeIdForPermissions}
                              onPublicAttachmentAdd={handlePublicAttachmentCount}
                              userData={userData}
                  ></MessageBox>
                <div className="footer-buttons">
                    {status === "loading" && (
                        <button className="loading-button">
                          <h2 className="alert-text">Loading...</h2>
                        </button>
                      )
                    }
                    {status === "success" && (
                                        <button className="success-button">
                                            <h2 className="alert-text">
                                               {checkIsActiveEvent()}
                                            </h2>
                                        </button>
                                    )}
                                    {/* {status === "error" && (
                                        <button className="error-button">
                                            <h2 className="alert-text">
                                                {isCloseEventActive &&
                                                    "Event closing failed. Try again!"}

                                                {isAirborne &&
                                                    "Aircraft is currently airborne.   Cannot reopen event."}
                                                {isAlreadyOpen &&
                                                    "Aircraft is already out of service.  Cannot reopen event."}
                                                { isInactiveEventType && 
                                                    "Event type is inactive.  Cannot reopen event."}
                                                {!isAirborne &&
                                                  !isAlreadyOpen &&
                                                  !isCloseEventActive &&
                                                  !isInactiveEventType &&
                                                    "Event update failed. Try again!"}
                                            </h2>
                                        </button>
                                    )} */}
                                    {status === "" && (
                                        <>
                                          <div className="button-wrapper-close-cancel">
                                            {!isReturnedToService && (
                                                    <div className="button-wrapper-modal">
                                                        <auro-button
                                                            variant="secondary"
                                                            fluid
                                                            onClick={onCloseEventClicked}
                                                            class={checkCloseButtonEnable()}
                                                        >
                                                            <span className="btnlabel-blue modal-button">
                                                                Close event
                                                            </span>
                                                        </auro-button>
                                                    </div>
                                                  )}
                                                {isReturnedToService &&(
                                                    <div className="button-wrapper-modal">
                                                        <auro-button
                                                            variant="secondary"
                                                            fluid
                                                            onClick={handleReopenClick}
                                                        >
                                                          <span className="btnlabel-blue modal-button">
                                                            Reopen event
                                                          </span>
                                                        </auro-button>
                                                    </div>
                                                )}
                                                {isReturnedToService && (
                                                    <div className="button-wrapper-modal">
                                                        <auro-button
                                                            variant="secondary"
                                                            fluid
                                                            onClick={handleClosedEventDrawerClose}
                                                        >
                                                          <span className="btnlabel-blue modal-button">
                                                            Cancel
                                                          </span>
                                                        </auro-button>
                                                    </div>
                                                )}
                                                {!isReturnedToService && (
                                                    <div className="button-wrapper-modal">
                                                        <auro-button
                                                            variant="secondary"
                                                            fluid
                                                             onClick={() => handleDrawerClose(false)}
                                                        >
                                                            <span className="btnlabel-blue modal-button">
                                                                Cancel
                                                            </span>
                                                        </auro-button>
                                                    </div>
                                                )}
                                            </div>

                      {isReturnedToService && (
                        <div className="button-wrapper-modal">
                          <auro-button
                            variant="primary"
                            fluid
                            onClick={handlePostClick}
                            class={
                              !isSubmitDisabled && isValidMessageBoxComment
                                ? ""
                                : "disabled"
                            }
                          >
                            <span className="btnlabel-white modal-button">
                              {"Save"}
                            </span>
                          </auro-button>
                        </div>
                      )}
                      {openModal && <CloseEventModal isValidComment={isValidComment} handlemessage={handleMessageDataChange} close={handleClosebox} proceed={handlePostClick} aircraftdetail={otsEventData?.AircraftRegistration}></CloseEventModal>}
                      {!isReturnedToService && (
                        <div className="button-wrapper-modal">
                          <auro-button
                            variant="primary"
                            fluid
                            onClick={handlePostClick}
                            class={
                              isSubmitDisabled || !isValidMessageBoxComment
                                ? "disabled"
                                : ""
                            }
                          >
                            <span className="btnlabel-white modal-button">Save</span>
                          </auro-button>
                        </div>
                      )}
                    </>
                  )}
                  </div>
                </footer>
              </span>
            )}
          </CustomTabPanel>
          {/* Parts tab - in permissions */}
          {otsEventData && !isReturnedToService &&
          <AuthorizationAccessCheck eventId={otsEventData?.Airline + ":" + otsEventData?.EventType} permission={ViewAogPartsTab} returnBoolean={false}>
          <CustomTabPanel value={value} index={1}>           
              <span className={checkCloseEventActive()}>
                <div className="ordered-item-list-header">
                  <span className="ordered-item-list-title">Ordered Parts</span>
                  <ViewParts refreshKey={partsRefreshKey} />

                </div>
                
                <footer className="modal-more-footer parts-footer" style={{height:'auto' }}>    
                  <OrderParts 
                  orderParts={orderedParts} 
                  onValidRequest={setValidRequest} 
                  onOrderPartsChange={setOrderedParts} 
                  resetTrigger={orderPartsResetTrigger}/>

                  <MessageBox className="edit-comment-box"
                              onMessageDataChange={handleMessageBoxValidComment}
                              eventData={postEventData}
                              resetBox={open}
                              activeBoxHeader={handleActiveHeader}
                              onTwilioMessageSent={handleTwilioMessageSent}
                              hiddenHeader={{ hideBoth: true, hideNote: true }}
                              eventTypeId={eventTypeIdForPermissions}
                              onPublicAttachmentAdd={handlePublicAttachmentCount}
                              userData={userData}
                  ></MessageBox>
                <div className="footer-buttons parts-footer">
                                        <>
                                          <div className="button-wrapper-modal">
                                     <Button
                                    variant="secondary"
                                    className="parts-style-buttons"
                                    onClick={() => handlePartDrawerCloseClick()}
                                  >
                                    Cancel
                                  </Button>

                        </div>
                    <div className="button-wrapper-modal">
                        <Button
                      variant="primary" 
                      disabled={!validRequest || !isValidMessageBoxComment || orderedParts.length === 0}
                      className="parts-style-buttons"
                      onClick={() => handlePartsPostClick()}
                    >
                      Request
                    </Button>
                    </div>
                    </>
                  </div>
                </footer>
              </span>
            
          </CustomTabPanel>
          </AuthorizationAccessCheck>}
          {!isReturnedToService && (
          <CustomTabPanel value={value} index={2}>
            {otsEventData && 
            <AuthorizationAccessCheck eventId={otsEventData?.Airline + ":" + otsEventData?.EventType} permission={ViewMoreTab} returnBoolean={false}>
            <MoreTabEdit airline={userData?.profile?.company} aircraftIsAirborne={aircraftInFlight} onMoreTabData={handleMoreTabData} resetInputs={open} moreOtsData={otsEventData} specialEventsAllowed={specialEventAllowed} >
              </MoreTabEdit>
              </AuthorizationAccessCheck>}
            <footer className="modal-more-footer">
                  <MessageBox
                  className="edit-comment-box"
                  onMessageDataChange={handleMessageBoxValidComment}
                  eventData={postEventData}
                  resetBox={open}
                  activeBoxHeader={handleActiveHeader}
                  onTwilioMessageSent={handleTwilioMessageSent}
                  hiddenHeader={{ hideBoth: true, hideNote: true }}
                  eventTypeId={eventTypeIdForPermissions}
                  onPublicAttachmentAdd={handlePublicAttachmentCount}
                  userData={userData}
                ></MessageBox>
                <div className="footer-buttons">
                {status === "loading" && (
                    <button className="loading-button">
                        <h2 className="alert-text">Loading...</h2>
                    </button>
                )}
                {status === "success" && (
                    <button className="success-button">
                        <h2 className="alert-text">
                          Event updated successfully!
                        </h2>
                    </button>
                )}
                {status === "error" && (
                    <button className="error-button">
                        <h2 className="alert-text">
                            Event update failed. Try again!
                        </h2>
                    </button>
                )}
                {status === "" && ( <>
                <div className="button-wrapper-modal">
                            <auro-button
                              variant="secondary"
                              fluid
                             onClick={handleDrawerClose}
                            >
                              <span className="btnlabel-blue modal-button">
                                Cancel
                              </span>
                            </auro-button>
                          </div>
<div className="button-wrapper-modal">
                          <auro-button
                            variant="primary"
                            fluid
                           onClick={handleMoreTabPostClick}
                            class={
                              isValidMessageBoxComment && isMoreTabValid
                                ? ""
                                : "disabled"
                            }
                          >
                            <span className="btnlabel-white modal-button">
                              {"Save"}
                            </span>
                          </auro-button>
                        </div>
                        </>)}
                </div>

                </footer>
          </CustomTabPanel>
          )}
        </Drawer>
      </Box>
    </div>
  );
}


function MappingNewValuesToOTSAircraftEntity(postedEventData:OtsAircraft, updatedOtsEvent: UpdatedOtsEvent, currentUTCTime: string) {
  //updating the UI data points for redux
  postedEventData.LastUpdatedTimeStampUTC = currentUTCTime;
  postedEventData.isPostClicked = true;
  //mapping as per updated values
  postedEventData.Station = updatedOtsEvent.station;
  postedEventData.ProblemText = updatedOtsEvent.problemText;
  postedEventData.EstimatedReturnToServiceTimeUTC = updatedOtsEvent.estimatedReturnToServiceTimeUTC? updatedOtsEvent.estimatedReturnToServiceTimeUTC : null;
  if(updatedOtsEvent.subAction.includes(SubActionConstant.ETR) && updatedOtsEvent.estimatedReturnToServiceTimeUTC && !updatedOtsEvent.adviseTimeUTC){
    postedEventData.ETRBump++;
  }
  postedEventData.AdviseTimeUTC = updatedOtsEvent.adviseTimeUTC? updatedOtsEvent.adviseTimeUTC : null;
  if(updatedOtsEvent.subAction.includes(SubActionConstant.ADV) && updatedOtsEvent.adviseTimeUTC && !updatedOtsEvent.estimatedReturnToServiceTimeUTC){
    postedEventData.ADVBump++;
  }
  postedEventData.Location = updatedOtsEvent.location;
  postedEventData.OutOfServiceDateTimeUTC = updatedOtsEvent.outOfServiceDateTimeUTC? updatedOtsEvent.outOfServiceDateTimeUTC : postedEventData.OutOfServiceDateTimeUTC;
  postedEventData.ATACode = updatedOtsEvent.ATACode;
  postedEventData.AtaCodeDescription = updatedOtsEvent.ataCodeDescription;
  postedEventData.EventType = updatedOtsEvent.eventType;
  postedEventData.EventTypeCategory = updatedOtsEvent.eventTypeCategory;
  postedEventData.EventTypeTo = updatedOtsEvent.eventTypeTo;
  postedEventData.EventTypeCategoryTo = updatedOtsEvent.eventTypeCategoryTo;
  postedEventData.ReturnToServiceTimeUTC = updatedOtsEvent.returnToServiceTimeUTC? updatedOtsEvent.returnToServiceTimeUTC : null;
  postedEventData.HasPublicAttachment = updatedOtsEvent.hasPublicAttachment;
  postedEventData.LastUpdatedBy = updatedOtsEvent.lastUpdatedBy || "";
  //For special event
  if(updatedOtsEvent.subAction.includes(SubActionConstant.SPECIAL_EVENT)){
    let newSpecialEvent: SpecialEventHistory | undefined;
    if(updatedOtsEvent.specialEvent){
      newSpecialEvent = {
        SpecialEventType: updatedOtsEvent.specialEvent.SpecialEventType,
        StationTo: updatedOtsEvent.specialEvent.SpecialEventStationTo,
        StationFrom: updatedOtsEvent.specialEvent.SpecialEventStationFrom,
        ChangedBy: "",
        UpdatedDateTimeUTC: ""
      }
    }
    if(newSpecialEvent){
      if (!Array.isArray(postedEventData.SpecialEventHistory)) {
        postedEventData.SpecialEventHistory = [];
      }
      else{
        postedEventData.SpecialEventHistory = [...postedEventData.SpecialEventHistory];
      }
      postedEventData.SpecialEventHistory.push(newSpecialEvent);
    }
  }
}